import {
  faChartLine,
  faComments,
  faGear,
} from "@fortawesome/duotone-light-svg-icons"
import { useTranslation } from "react-i18next"

import TabNavItem from "../../../components/tabNav/TabNavItem"
import useMobile from "../../../hooks/useMobile"
import { usePageWrapperScroll } from "../../../hooks/usePageWrapperScroll"
import { useFlaggedDoterChatLogsQuery } from "../../../networking/chatSessions/queries"
import { ChildTabNavOption } from "../../../types"
import useChildTabNavStore from "../hooks/useChildTabNavStore"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"
import useChildIsOnboarded from "../hooks/useIsChildOnboarded"

const ChildTabNav = () => {
  const { selectedTab, setSelectedTab } = useChildTabNavStore()
  const { t } = useTranslation()
  const isMobile = useMobile()
  const childIsOnboarded = useChildIsOnboarded()
  const { isScrolled } = usePageWrapperScroll()

  const { data: flaggedConvos } = useFlaggedDoterChatLogsQuery()
  const { selectedUserId } = useFamilyUserSelectStore()
  const filteredConvos = flaggedConvos?.filter(
    (convo) => convo.user_id === selectedUserId
  )
  const unreadConvos = filteredConvos?.filter((convo) => !convo.date_read)
  const hasUnreadConvos = unreadConvos && unreadConvos.length > 0

  if (!childIsOnboarded) return <></>

  return (
    <div
      className={`flex flex-row sticky top-[80px] z-20 ${isMobile ? "bg-white justify-evenly border-b border-borderPrimary" : "bg-bgXLightGray justify-start"} ${isScrolled ? "shadow-low-bottom" : ""}`}
    >
      <TabNavItem
        label={t("FT_TAB_PROGRESS")}
        onClick={() => setSelectedTab(ChildTabNavOption.PROGRESS)}
        icon={faChartLine}
        isSelected={selectedTab === ChildTabNavOption.PROGRESS}
      />
      <TabNavItem
        label={t("FT_TAB_DOTER_CHATS")}
        onClick={() => setSelectedTab(ChildTabNavOption.DOTER_CHATS)}
        icon={faComments}
        isSelected={selectedTab === ChildTabNavOption.DOTER_CHATS}
        showNotificationDot={hasUnreadConvos}
      />
      <TabNavItem
        label={t("FT_TAB_SETTINGS")}
        onClick={() => setSelectedTab(ChildTabNavOption.SETTINGS)}
        icon={faGear}
        isSelected={selectedTab === ChildTabNavOption.SETTINGS}
      />
    </div>
  )
}

export default ChildTabNav
